import React, { Component} from 'react';
import imgCaptn from '../../../../images/CapRun.gif'
import imgN3RD from '../../../../images/N3RDRun.gif'
import imgSniper from '../../../../images/SnipeRun.gif'
import imgDr from '../../../../images/DocRun.gif'
// import API from'../utilities/API'
// import {  NavLink, Redirect  } from 'react-router-dom'

class vcCharacterInput extends Component {
  
  constructor(props) {
    super(props);
    
    //this.handleUnTouch = this.handleUnTouch.bind(this);
  
    
    this.CAPSkills = ['Pass','1 Liner','Massive-Attack','Tooty-Booty','Charge'];
    this.N3RDSkills = ['Pass','Hack', 'Nano Wall', 'Nano Slice','Mega Laser'];
    this.SniperSkills = ['Pass','Hand Cannon', 'Head Shot', 'Cloak', 'Electric Smoke'];
    this.DoctorSkills =['Pass', 'Heal','Poison Dart','Poison Grenade', 'Resurect'];
    
    switch(this.props.char){
        case 'CAP':
          this.charname = "The Captain"
          this.charpic = imgCaptn;
          this.charActions = this.CAPSkills;
          break;
        case 'N3RD':
          this.charname = "N3RD"
          this.charpic = imgN3RD;
          this.charActions = this.N3RDSkills;
          break;
        case 'SNIPE':
          this.charname = "Lt. Darkshot"
          this.charpic = imgSniper;
          this.charActions = this.SniperSkills;
          break;  
        case 'DOC':
        this.charname = "McHeals M.D."
          this.charpic = imgDr;
          this.charActions = this.DoctorSkills;
          break;
        default:
          this.charpic = imgCaptn;
          this.charActions =  this.CAPSkills;
          break;
   
        }
      
        this.state = {
      char: this.props.char,
      action: 'Pass',
      target: '',
      charActions: this.charActions
      
    }
        }
componentDidMount(){
  this.dd = [];
  this.dd.length=0;
  this.dd = this.state.charActions.map((X)=>(<div onClick={this.handleActionEvent}  className="dropdown-item" value={X}>{X}</div>))

  this.friendlies = ['Captain','N3RD','SNIPER','DOC'];  
  this.enemies = this.friendlies.map((X)=>(<div onClick={this.handleTargetEvent} className="dropdown-item" value={X}>{X}</div>))
  
}  

handleTouch = (e) => {
  e.preventDefault();  
  this.props.setChar({name:this.charname, type: this.state.char});
  this.setState({char: this.props.char});
}


handleActionEvent = (e) => {
  e.preventDefault();
  
  this.setState({action: e.target.getAttribute("value")});  
 
}
handleSelectionEvent = (e) => {
 console.log('SELECT');
}
handleTargetEvent = (e) => {
  
  e.preventDefault()
  this.setState({target: e.target.getAttribute("value")});
   
}

   
    render() 
     {
       
      const pgImg ={ width:'6rem', height:'8rem', float:"left"}


      const stylcommands={'fontSize': '2em'}
      let sty = {'background': 'linear-gradient(to bottom right, darkgrey, black)', 'borderRadius':'0 25px 0 25px'}; 
      
      
      let targnme = 'None';
      targnme = this.props.getCharTarget(this.state.char);
        

      if(this.state.char===this.props.getSelChar()||this.state.char===this.props.getSelChar().type){
        sty = {'background':'linear-gradient(to bottom right, green, black)', 'borderRadius':'0 25px 0 25px'}
        targnme = this.props.getSelEnemyObj().name
      } 
      

      
      let targs =[];
      if(this.state.target){
        targs =  this.state.target.slice();
      }
      
      if(this.props.NMES){
        targs=this.props.NMES.map((X)=>(<div onClick={this.handleTargetEvent} value={X.name} className="dropdown-item">{X.name}</div>));
      }    
      if(this.state.action==='Heal'||this.state.action==='Resurect'||this.state.action==='Nano Wall'||this.state.action==='Cloak'){
        targs=this.friendlies.map((X)=>(<div onClick={this.handleTargetEvent} value={X} className="dropdown-item">{X}</div>));
        targnme = "None";
      }
      if(this.state.action==='Poison Grenade'||this.state.action==='Electric Smoke'){
        targnme = "AOE";
        targs=(<div onClick={this.handleTargetEvent} value={"AOE"} className="dropdown-item">{"AOE"}</div>);
      }
      // console.log('TARGS====================================================', targs);
      return (
        
        <div style={sty} onClick={this.handleTouch}>        
              {this.state.act}
              <h2>{this.charname}</h2>
           
          
          <img className="img-thumbnail img-responsive mr-3" style={pgImg} src={this.charpic} alt="charpic"/>
         
          <div style={stylcommands} className="dropdown">
            <div>
            <div>
              Hit Points:
              </div>
              <div>
              Buffs:
              </div>
              <div>
              Nerfs:
              </div>
            </div>
            <div className="dropdown">Action:
              <button className="btn btn-secondary dropdown-toggle" type="button"  id="action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {this.state.action}

              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {this.dd}
              </div>
            </div>
            <div className="dropdown">Target:
              <button onClick={this.handleSelectionEvent} ref="TargetDD" className="btn btn-secondary dropdown-toggle" type="button"  id="target" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                 {targnme} 
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {targs}
              </div>
            </div>            
        </div>    
        </div> 
           );  
    }  
}




export default vcCharacterInput; 


// WEBPACK FOOTER //
// ./src/components/Games/VoidCheddar/Parts/vcCharacterCard.js